import PropTypes from 'prop-types';
import React from 'react'
import Select from 'react-select';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { filter } from 'underscore'


export default class extends React.Component {
    static propTypes = {
		maxTags: PropTypes.number,
		disabled: PropTypes.bool,
		interests: PropTypes.array.isRequired,
		selectedInterests: PropTypes.bool,
		updatedAction: PropTypes.func,
	};

    state = {
        selectedInterests: this.props.selectedInterests,
        interests: [
            { value: 'one', label: 'One' },
            { value: 'two', label: 'Two' }
        ]
    };

    changeTags = (interests) => {
		var max = this.props.maxTags ? this.props.maxTags : 999999;
		if( interests.length > max ) {
			interests = interests.slice(0,max)
			NotificationManager.error('You can only select ' + max + ' interests here', '', 3000);
		}
		this.setState({
			selectedInterests: interests
		})
		this.props.updatedAction('interests', interests)
	};

    render() {

		let interests = filter(this.props.interests, {hidden: false})

		return (
			<div>
				<Select
					name="interests"
					multi={true}
					labelKey="title"
					valueKey="ID"
					disabled={this.props.disabled}
					value={this.state.selectedInterests}
					clearable={false}
					placeholder="Choose up to 3 tags to use for this Camp"
					options={interests}
					onChange={this.changeTags}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Interests/components/Tag.js